import React, { useEffect, useState, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import HeaderMenu from './components/headerComponent';
import Head from './components/head';
import './css/style.min.css';
import './css/sp_style.min.css';
import FrontPage from './components/FrontPage';
import BackgroundCanvas from './components/BackgroundCanvas';
import Loading from './components/Loading';

const HomePage = () => (
  <>
    <FrontPage />
    <Suspense fallback={null}>
       <BackgroundCanvas />
    </Suspense>
  </>
);

const App = () => {
  const [isLoading, setIsLoading] = useState(true); // ローディングフラグ

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // ローディング終了
    }, 3500);

    return () => clearTimeout(timer); // クリーンアップ
  }, []);

  return (
    <>
      {isLoading && <Loading />} {/* ローディング画面を表示 */}
      {!isLoading && (
        <Router>
          <Suspense fallback={<Loading />}>
            <Head />
            <HeaderMenu />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/loading" element={<Loading />} />
            </Routes>
          </Suspense>
        </Router>
      )}
    </>
  );
};

const appRoot = document.getElementById('app');
const app = ReactDOM.createRoot(appRoot);
app.render(<App />);
